import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const UserInfoDialog = ({ username, password, onClose }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(password);
  };

  return (
    <Dialog
      open={true}
      sx={{
        "& .MuiDialog-paper": {
          width: "1000px",
          maxWidth: "none",
        },
      }}
    >
      <DialogTitle>User Info</DialogTitle>
      <DialogContent>
        <Typography>
          Password is shown only once, so copy it from here
        </Typography>
        <Table sx={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "150px" }}></TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ width: "150px" }}>Username</TableCell>
              <TableCell sx={{ width: "100%" }}>
                <TextField
                  InputProps={{ readOnly: true }}
                  value={username}
                  fullWidth
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "150px" }}>Password</TableCell>
              <TableCell sx={{ width: "100%" }}>
                <TextField
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          title="Copy"
                          onClick={handleCopy}
                          edge="end"
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={password}
                  fullWidth
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Button id="close" onClick={onClose} sx={{ mt: 2 }}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default UserInfoDialog;
